import DashboardIcon from '@mui/icons-material/Dashboard';

import DashboardHome from './DashboardHome';

const exports = {
    List: DashboardHome,
    Icon: DashboardIcon,
};
export default exports;
